// useParams takes address page name from address bar
// MainContent5 and AsideContent5 defined within
import { useParams } from "react-router-dom";
import React from "react";
import Seo from "../Seo";
import GoToTop from "../GoToTop";
import ResourcesList from "../assets/ResourcesList";
import { Link } from "react-router-dom";
import AsideContent2 from "../AsideContent2";



const ResourcePage = () => {
    const params = useParams();
    const articleId = params.articleId;
    const quoteId = params.quoteId;
    const article = ResourcesList.list.find(article => article.objectName === articleId);
    const quote = article.quotes.find(quote => quote.id === quoteId);
    
    // console.log(articleId);
    // console.log(quoteId);
    // console.log('content:', article)
    // console.log('quotedate: ', quote.title);

    function MainContent5() {
        
        return (
          <>
          <Seo title={quote.tabHeading} description={quote.metaDescription} keywords={quote.keywords} />
          <h2 className="sectionHeader"><span className="by">{article.by}</span>{article.firstName} {article.lastName} <span className="by">{article.dates}</span></h2>
          <blockquote className="main">
          <p><b><i>{quote.from}</i></b><cite className="citeTitle">{quote.title}</cite></p>
          {quote.content.map((paragraph, i) => {
            if (paragraph.list) { 
              return (
                <>
                <p key={i}>
                    <ul>
                        {paragraph.list.map((listItem, li) => {
                            return (<li key={li}><b>{listItem.bold}</b>{listItem.normal}</li>)
                        })}
                    </ul>
                </p>
                </>
              )} else {
                return (
                <p key={i}><b>{paragraph.bold}</b>{paragraph.normal}<b>{paragraph.bold2}</b></p>
                )}    
            })}
          </blockquote>
          </>
        );
      };
      // function AsideContent5() {
      //   const EmbedImage = article.image; 
      //   return (
      //       <>
      //       <div className="embedImage">    
      //       <EmbedImage />
      //       </div>
      //       <h2 className="sectionHeader">Considerations</h2>
      //       <div className="main">
      //       {quote.considerations.map((quoteBlock, id) => {
      //           return (
      //               <React.Fragment key={id}>
      //               {quoteBlock.content.map((paragraph, i) => {
      //                   return (
      //                       <p key={i}>{paragraph}</p>
      //                   )
      //               })}
      //               <p><b>{quoteBlock.title}</b> {quoteBlock.date}</p>
      //               <hr />
      //               </React.Fragment>
      //       )})}          
      //       </div>
      //       </>
      //   );
      // };

    return (
        <div className="content">
            <main>
                <MainContent5 />
                <h2 className="back"><Link to="/GreatQuotes" title="Back to Great Quotes" className="backLink link">- BACK -</Link></h2>
            </main>
            <aside>
                <AsideContent2 resource={article} />
            </aside>
            <GoToTop />
  	    </div>
    );
};
export default ResourcePage;